// eslint-disable react/jsx-props-no-spreading -- Disabling as it's passed from the parent module.
import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import { compose } from 'redux';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { addErrorToReport, loadLanguagePack } from '@americanexpress/one-app-ducks';
import TravelSearchDatePicker from './components/TravelSearchDatePicker';
import { MODULE_NAME } from './constants/moduleName';

export const TravelSearchDatePickerWrapper = ({
  locale,
  languageData,
  ...props
}) => {
  if (languageData) {
    return (
      <IntlProvider locale={locale} messages={languageData}>
        {/* eslint-disable-next-line react/jsx-props-no-spreading -- prop spreading for wrapper */}
        <TravelSearchDatePicker {...props} />
      </IntlProvider>
    );
  }
  return null;
};
TravelSearchDatePickerWrapper.propTypes = {
  locale: PropTypes.string.isRequired,
  languageData: PropTypes.shape({}).isRequired,
};

export const loadModuleData = async ({ store: { dispatch } }) => {
  try {
    await Promise.all([
      dispatch(loadLanguagePack(MODULE_NAME, { fallbackLocale: 'en-US' })),
    ]);
  } catch (error) {
    dispatch(addErrorToReport(
      error,
      {
        collectionMethod: 'loadModuleData error',
        moduleId: 'axp-travel-search-date-picker',
        componentName: 'src/TravelSearchDatePickerWrapper',
      }
    ));
  }
};

TravelSearchDatePickerWrapper.holocron = {
  name: MODULE_NAME,
  loadModuleData,
};

const hocChain = compose(
  oneAppModuleWrapper(MODULE_NAME)
);

export default hocChain(TravelSearchDatePickerWrapper);
